<template>
    <div class="abnormal">
        <ChildPublic v-if="isChild"></ChildPublic>
        <Public v-else-if="!isChild"></Public>

        <div class="abnormal-content right-content">
            <el-tabs v-model="activeIndex" type="card" @tab-click="handleClick">
                <el-tab-pane label="离线和异常设备" name="1">
                    <AbnormalAmmeter></AbnormalAmmeter>
                </el-tab-pane>
                <el-tab-pane label="欠费房间" name="2">
                    <AbnormalArrears></AbnormalArrears>
                </el-tab-pane>
                <el-tab-pane label="异常房间" name="3">
                    <AbnormalAbnormal></AbnormalAbnormal>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    import Public from '@/views/Public.vue'
    import ChildPublic from '@/views/ChildPublic.vue'
    import AbnormalAmmeter from '@/components/AbnormalAmmeter.vue'
    import AbnormalArrears from '@/components/AbnormalArrears.vue'
    import AbnormalAbnormal from '@/components/AbnormalAbnormal.vue'

    export default {
        name: "Abnormal",
        components: {
            Public,
            AbnormalAmmeter,
            AbnormalArrears,
            AbnormalAbnormal,
            ChildPublic,
        },
        data() {
            return {
                dialogFormVisible: false,
                formLabelWidth: '80px',
                form:{
                    addr: '',
                    abnormal:'',
                },
                activeIndex: '1',
                isChild: false,
            };
        },
        mounted() {
            if (window.localStorage.isChild == 0) {
                this.isChild = false;
            } else {
                this.isChild = true;
            }
            this.activeIndex = store.state.abnormalTableTabIndex;
        },
        methods:{
            handleClick(tab, event) {
                store.commit('assignAbnormalTableTabIndex', this.activeIndex);
            },
        }
    }
</script>

<style scoped>
    .abnormal {
        height: 100%;
    }

    .abnormal-content {
        margin: 0.1rem 5rem 0.1rem 0.15rem;
    }

    .right-content .abnormal-table {
        margin-right: 0.3rem;
    }

    .select-search{
        margin: 0 0.3rem 0.2rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

    }
    .select-group {
        /*margin: 0 0 0.2rem 0.15rem;*/
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width:100%;
    }


    .select-group .el-select {
        margin-right: 5%;
    }

    .button-group {
        display: flex;
        flex-direction: row-reverse;
    }
    .button-group .el-button{
        margin-left: 5%;
    }

</style>